import React, { PureComponent } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { getProjectInfo, getProjectSpreadPic } from '../../api/cgi/knowledge';
import _ from 'lodash';
import { Loading } from '@tencent/spaui';
import { parse, stringify } from 'query-string';
import token from '@/utils/token';
import { getWatermarkUrl } from '@/components/watermark';

class ArticleDetailBrand extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      fileNameList: [],
      loading: false,
    };
    this.goBack = this.goBack.bind(this);
  }
  componentDidMount() {
    this.getArticleDetail();
  }
  getArticleDetail() {
    const {
      accountInfo: { knowledge_token },
      location,
    } = this.props;
    let id = parse(location.search).id;
    this.setState({
      loading: false,
    });
    getProjectInfo({ data: { knowledge_token, project_code: id } }).then((res) => {
      const { code, data = [] } = res;
      const listData = data.list;
      this.setState({
        loading: true,
      });
      if (code == 0) {
        const obj = listData.find((x) => {
          return x.field_name == 'Fproject_name';
        });
        const objPic = listData.find((x) => {
          // 推广图对象
          return x.field_name == 'Fspread_pic';
        });
        const fileNameList = listData
          .filter((x) => !!x.text && x.field_name !== 'Fspread_pic')
          .sort((a, b) => {
            return a.text.length - b.text.length;
          });
        this.setState({
          fileNameList,
          title: obj.text,
          spread_pic_id: objPic.value,
          warterMark: data.warterMark,
        });
      }
    });
  }

  goBack() {
    this.props.history.goBack();
  }
  render() {
    const { loading, fileNameList, title, warterMark = {}, spread_pic_id } = this.state;
    let warterMarkSrc = getWatermarkUrl(_.values(warterMark).join(' '));

    const {
      accountInfo: { knowledge_token },
      location,
    } = this.props;

    const data = {
      spread_pic_id,
      knowledge_token,
    };

    const hasPicUrl = `${getProjectSpreadPic()}?${stringify(data)}&g_tk=${token.getACSRFToken()}`;
    return (
      <div className="help_detail_container" style={{ backgroundImage: `url(${warterMarkSrc})` }}>
        {!loading ? (
          <Loading type="svg" display="center" />
        ) : (
          <div className="help_content_main">
            <div className="crumbs help_content_main_title">
              <a href="#" onClick={this.goBack} style={{ cursor: 'pointer' }} className="front">
                全部
              </a>
              <i className="spaui-icon icon-crumb-arr"></i> {title}
            </div>
            <div className="project-block">
              <div className="project-tittle">项目信息</div>
              <div className="project-mainbody">
                <div className="project-body">
                  {fileNameList.map((x) => {
                    return (
                      <div key={x.field_name} className="project-part">
                        <div className="project-mainpart">
                          <span className="project-parttitle" style={{ marginRight: 10 }}>
                            {x.field_explain} :
                          </span>
                          <div className="project-partcontent">{x.text}</div>
                        </div>
                      </div>
                    );
                  })}
                  <div className="project-img">
                    <div>推广图：</div>
                    {spread_pic_id ? <img style={{ width: '100%', height: '100%' }} src={hasPicUrl} /> : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
  return {
    accountInfo: state.knowledge.knowledge_info,
  };
}
export default withRouter(connect(mapStateToProps)(ArticleDetailBrand));
